// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ id:0,label:'编码：',spanRows:12,type:'input',modelValue:'deptCode',prefix:'el-icon-require',zdy:'zdy',disabled:true },
	{ id:1,label:'有效状态：',spanRows:12,type:'select',modelValue:'status',prefix:'el-icon-require',op:'statusOptions' },
	{ id:2,label:'科室名称：',spanRows:12,type:'input',modelValue:'deptName',prefix:'el-icon-require',im:true },
	// { label:'显示顺序：',spanRows:12,type:'input',modelValue:'pyVal',im:false },
	{ id:3,label:'拼音简码：',spanRows:12,type:'input',modelValue:'pyCode',im:true,placeholder:'请输入身份证号' },
	{ id:4,label:'负责人：',spanRows:12,type:'select',modelValue:'personInCharge',placeholder:'',op:'fzrOptions'},
	{ id:5,label:'负责人电话',spanRows:12,type:'input',modelValue:'personInChargeTel',im:false,placeholder:'',op:''},
	{ id:6,label:'科室专业：',spanRows:12,type:'selectKsName',modelValue:'specialtyName',im:false,placeholder:'',op:'specialtyNameOptions'},
	// { label:'上级科室：',spanRows:12,type:'select',modelValue:'inJobVal',im:false,placeholder:'',op:''},
	{ id:7,label:'物理位置：',spanRows:12,type:'input',modelValue:'physicalPosition',im:false,placeholder:'',op:'statusOptions' },
	{ id:8,label:'返诊期限：',spanRows:12,type:'input',modelValue:'returnVisitNum',im:false,placeholder:'', },
	{ id:9,label:'隶属诊所：',spanRows:12,type:'select',modelValue:'institutionId',im:false,placeholder:'',op:'clinicOptions' },
	{ id:10,label:'科室类型：',spanRows:12,type:'select',modelValue:'deptType',im:false,placeholder:'',op:'deptTypeOptions' },
	{ id:11,label:'医学类型：',spanRows:12,type:'select',modelValue:'medicineType',im:false,placeholder:'',op:'medicineTypeOptions' },
	{ id:12,label:'备注：',spanRows:24,type:'input',modelValue:'remark',im:false,placeholder:'',op:'statusOptions' },
	
]

